import axios from "axios"
import moment from "moment"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL

// ✅ Reusable headers generator
const getHeaders = () => {
  const apiToken = JSON.parse(localStorage.getItem("Token"))
  return {
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }
}

// ✅ 1. Get Staff Profile
export const getStaffProfileAPI = async () => {
  try {
    const response = await axios.get(
      `${liveApiUrl}/api/teacher-profile/get-profile`,
      { headers: getHeaders() }
    )
    return response
  } catch (error) {
    console.error("❌ Error getting staff profile:", error)
    throw error
  }
}

// ✅ 2. Get Staff Attendance
export const getStaffAttendanceAPI = async payload => {
  try {
    const response = await axios.post(
      `${liveApiUrl}/api/teacher-staffAttendance/staffAttendanceApp`,
      payload,
      { headers: getHeaders() }
    )
    return response
  } catch (error) {
    console.error("❌ Error getting staff attendance:", error)
    throw error
  }
}

// ✅ 3. Get Staff Timetable for Today
export const getStaffTimeTableAPI = async () => {
  try {
    const headers = getHeaders()

    const { data: days = [] } = await axios.get(
      `${liveApiUrl}/api/teacher-timetable/timetabledays`,
      { headers }
    )

    const today = moment().format("dddd")
    const currentDay = days.find(day => day.day === today)

    if (!currentDay) {
      throw new Error(`⛔ Day "${today}" not found in timetable days.`)
    }

    const { data: timetable } = await axios.post(
      `${liveApiUrl}/api/teacher-timetable/timetable`,
      { dayid: currentDay.id },
      { headers }
    )

    return timetable
  } catch (error) {
    console.error("❌ Error getting timetable:", error)
    throw error
  }
}
